import styled from 'styled-components';

export const LimitRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--sizing-sm);
`;

export const InfoBox = styled.div`
  border: 1px solid var(--border-gray);
  border-radius: var(--border-radius-xs);
  padding: var(--sizing-sm);
  background: var(--background-gray-light);

  width: 800px;
  max-width: 100%;

  ul {
    list-style: disc;
    padding-left: var(--sizing-md);
    margin: 0;
  }

  li {
    font-weight: 300;
  }

  li + li {
    margin-top: var(--sizing-xs);
  }

  /* "To qualify..." sub-heading and closing note inside the DCFSA eligibility box */
  .qualify-title {
    margin-bottom: var(--sizing-xs);
  }

  .qualify-note {
    margin-top: var(--sizing-sm);
  }
`;
